module.exports = __webpack_public_path__ + "img/BE0715622844.9bd824c4.svg";